import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/industry.scss';
import Color from '@tool/color';
import { newRate } from '@tool/index';
import Effect from './component/effect';
import Manpower from './component/manpower';
import Talent from './component/talent';
import { DtaileIcon } from '@/styled/icon';
import Title from '../../styled/title';
import getShowModule from '../store/common';
import moChange from '../store/change';

interface IProps {}
interface IState {}

const Industry = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { modelList } = moChange;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="dash-industry-warp industry-011">
      {(getShowModule('industry', '人效', modelList) ||
        getShowModule('industry', '人才指标', modelList) ||
        getShowModule('industry', '人才需求', modelList)) && (
        <section className="title">
          <Title text="行业数据" />
        </section>
      )}
      {getShowModule('industry', '人效', modelList) && <Effect />}
      {getShowModule('industry', '人才指标', modelList) && <Manpower />}
      {getShowModule('industry', '人才需求', modelList) && <Talent />}
    </section>
  );
};

export default observer(Industry);
